"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._TypecheckNPYWorkerLoader = exports._TypecheckNPYLoader = exports.NPYWorkerLoader = exports.NPYLoader = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _version = require("./lib/utils/version");
var _parseNpy = require("./lib/parsers/parse-npy");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var NPY_MAGIC_NUMBER = new Uint8Array([147, 78, 85, 77, 80, 89]);

var NPYWorkerLoader = {
  name: 'NPY',
  id: 'npy',
  module: 'textures',
  version: _version.VERSION,
  worker: true,
  extensions: ['npy'],
  mimeTypes: [],
  tests: [NPY_MAGIC_NUMBER.buffer],
  options: {
    npy: {}
  }
};

exports.NPYWorkerLoader = NPYWorkerLoader;
var NPYLoader = _objectSpread(_objectSpread({}, NPYWorkerLoader), {}, {
  parseSync: _parseNpy.parseNPY,
  parse: function () {
    var _parse = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(arrayBuffer, options) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _parseNpy.parseNPY)(arrayBuffer, options));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function parse(_x, _x2) {
      return _parse.apply(this, arguments);
    }
    return parse;
  }()
});

exports.NPYLoader = NPYLoader;
var _TypecheckNPYWorkerLoader = NPYWorkerLoader;
exports._TypecheckNPYWorkerLoader = _TypecheckNPYWorkerLoader;
var _TypecheckNPYLoader = NPYLoader;
exports._TypecheckNPYLoader = _TypecheckNPYLoader;
//# sourceMappingURL=npy-loader.js.map